import React from 'react';
import OrgSelect from './OrgSelect.js';
import { requestPasswordReset } from '../Utils/AuthUtils';
import loading_gif from '../Images/loading.gif';
import './UserPrefs.css';

class UserPrefs extends React.Component {
	constructor(props) {
		super(props);
				
		this.state = {
			firstName: this.props.userData ? this.props.userData.firstName : '',
			lastName: this.props.userData ? this.props.userData.lastName : '',
			passwordMessage: ''
		};
		
		// Function bindings:
		this.handleChange = this.handleChange.bind(this);
		this.submitNameChanges = this.submitNameChanges.bind(this);
		this.submitPWResetRequest = this.submitPWResetRequest.bind(this);
	}
	
	// User typed something into a text input
	handleChange(changeEvent) {
		const newVal = changeEvent.target.value;
		this.setState({
			[changeEvent.target.id]: newVal
		});
	}
	
	// User hit the Save Name Changes button. Save dem changes
	submitNameChanges() {
		if (
			!this.state.firstName || this.state.firstName.length <= 1
			|| !this.state.lastName || this.state.lastName.length <= 1
		) {
			return;
		}
		var newUserData = this.props.userData;
		newUserData.firstName = this.state.firstName;
		newUserData.lastName = this.state.lastName;
		newUserData.modifiedUser = newUserData.id;
		newUserData.modifiedDate = Date.now();

		fetch('/webpub-services/WPUserAPI/updateWPUser', {
			method: 'PUT',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(newUserData)
		})
		.then(res => res.json())
		.then(
			(result) => {
				this.props.forceUserUpdateFn();
			},

			(error) => {
				// TODO: Do something if this fails, maybe?
			}
		);
	}
	
	// User hit the password reset button. Shoot 'em an email
	submitPWResetRequest() {
		const submitObj = {
			url: window.location.protocol + '//' + window.location.hostname, // try to be environment-agnostic
			resetEmail: this.props.userData.email
		}
		
		requestPasswordReset(submitObj)
			.then( () => this.setState({ passwordMessage: "You should receive an email with instructions shortly!" }));
	}
	
	render() {
		// Sanity checking
		if (!this.props.userData) { // Display nothing until we're ready for user input
			return <div>Loading <img src={loading_gif} alt='loading gif' style={{ verticalAlign: 'middle' }} /></div>;
		}
		
		return (
			<div>
			<h2>User Preferences for 
				<span style={{textTransform: 'capitalize'}}>
					{' ' + this.props.userData.firstName + ' ' + this.props.userData.lastName}
				</span>
			</h2>
			<div>
				<label htmlFor='defaultOrgSelect' style={{display: 'block'}}>Select Default Organization {" "} </label>
				<OrgSelect 
					id='defaultOrgSelect' 
					orgChangeFn={this.props.orgChangeFn} 
					setDefault="true" 
					selectedOrg={this.props.userData.startOrg} 
					orgList={this.props.orgList} 
					userId={this.props.userData.id} 
				/>
			</div>
			<hr />
			<div>
				<label 
					htmlFor='updateFirstName' 
					style={{display: 'block'}}
				>
					First Name
				</label>
				<input 
					type='text'
					id='firstName'
					maxLength={50}
					minLength={2}
					value={this.state.firstName}
					onChange={this.handleChange}
				/>
				<br />
				<label 
					htmlFor='updateLastName' 
					style={{display: 'block'}}
				>
					Last Name
				</label>
				<input 
					type='text'
					id='lastName'
					maxLength={50}
					minLength={2}
					value={this.state.lastName}
					onChange={this.handleChange}
				/>
				<br />
				<div className='user-prefs-button-container'>
					<div 
						className='user-prefs-button clickable'
						onClick={this.submitNameChanges}
					>
						Save Name Changes
					</div>
				</div>
			</div>
			<hr />
			<div>
				<div className='user-prefs-button-container'>
					<div 
						className='user-prefs-button clickable'
						onClick={this.submitPWResetRequest}
					>
						Request Password Reset
					</div>
				</div>
				<div className='error-text'>
					{this.state.passwordMessage}
				</div>
			</div>
			</div>
		);
	}
}

export default UserPrefs;